module.exports = __webpack_public_path__ + "img/L1060510.0e7cdbd1.jpg";